import { render, staticRenderFns } from "./StudentsTabAnonymized.vue?vue&type=template&id=3d8e1b2c&scoped=true&"
import script from "./StudentsTabAnonymized.vue?vue&type=script&lang=js&"
export * from "./StudentsTabAnonymized.vue?vue&type=script&lang=js&"
import style0 from "./StudentsTabAnonymized.vue?vue&type=style&index=0&id=3d8e1b2c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d8e1b2c",
  null
  
)

export default component.exports